import {
  TComponentNames,
  TTvDashboardWebsocketComponentSubscribeMessage,
  TTvDashboardWebsocketConfig,
  TWebSocketConnectReason,
} from '@monorepo/types';
import { Action } from '@ngrx/store';
import { TConnectionStatus, TTvDashboardActionType } from './tv-dashboard.model';

export class ConnectWebSocket implements Action {
  readonly type = TTvDashboardActionType.ConnectWebSocket;
  constructor(public wsConfig: TTvDashboardWebsocketConfig, public reason: TWebSocketConnectReason) {}
}

export class DisconnectWebSocket implements Action {
  readonly type = TTvDashboardActionType.DisconnectWebSocket;
  constructor() {}
}

export class WebSocketStatus implements Action {
  readonly type = TTvDashboardActionType.ConnectionStatus;
  constructor(public connectionStatus: TConnectionStatus) {}
}

export class UpdateData implements Action {
  readonly type = TTvDashboardActionType.UpdateData;
  constructor(public channelId: string, public message: unknown) {}
}

export class SendDataToWebsocket implements Action {
  readonly type = TTvDashboardActionType.SendDataToWebsocket;
  constructor(public payload: TTvDashboardWebsocketComponentSubscribeMessage) {}
}

export class StartListeningMessages implements Action {
  readonly type = TTvDashboardActionType.StartListeningMessages;
  constructor() {}
}

export class MapChannelToComponent implements Action {
  readonly type = TTvDashboardActionType.MapChannelToComponent;
  constructor(public channelId: string, public componentName: TComponentNames) {}
}

export type TTvDashboardActions =
  | ConnectWebSocket
  | DisconnectWebSocket
  | WebSocketStatus
  | UpdateData
  | StartListeningMessages
  | SendDataToWebsocket
  | MapChannelToComponent;
